// extracted by mini-css-extract-plugin
module.exports = {"link-blue":"#325bbd","md":"MarkdownParser-module__md___2rNkO"};